/*
 *  I11PERCHARESI18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 22:04:58 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I11PERCHARES_SECTION_0_TITLE:
    'Calculez les pertes de charges de votre conduites, pour ce faire, commencez par calculer celles dues à la conduite',
  I11PERCHARES_I11PERCHADISCHA: 'Linéaire',
  I11PERCHARES_res_diamInt: 'Diamètre intérieur tuyau',
  I11PERCHARES_res_contextCha_pdc: 'Pertes de charges régulière',
  I11PERCHARES_res_vitesse: 'Vitesse',
  I11PERCHARES_SECTION_1_TITLE: 'Calculez les pertes de charges Singulières',
  I11PERCHARES_in_accident: "Nombre de type d'accident(s)",
  I11PERCHARES_pdcUnitSelected_uuid: 'Unité de calcul perte de charge: ',
  I11PERCHARES_res_totalDzeta: 'Total dzeta',
  I11PERCHARES_res_pdcFrottement: 'Pertes de charges par frottement',
  I11PERCHARES_res_pdfTotal: 'Pertes de charges total du réseau'
}
